import moment from 'moment'
import { intl } from 'utils'
import messages from './messages'
import {
  getCardNumberDigits,
  isValidCardNumber,
} from './cardRules'

export {
  getCardNumberDigits,
  isAmexCardBrand,
  isAmexCardNumber,
  isJaywanCardNumber,
  isValidCardNumber,
} from './cardRules'

export function requiredRule(item, isMsg) {
  return {
    rules: [
      {
        required: true,
        message: isMsg ? item : intl().formatMessage(messages.requiredRule, { item })
      }
    ]
  }
}
export function agreementRule(item = intl().formatMessage(messages.formItemAgreement)) {
  return {
    initialValue: true,
    valuePropName: 'checked',
    rules: [
      {
        validator(rule, value, callback, source, options) {
          console.log(value)
          if (!value) {
            // eslint-disable-next-line standard/no-callback-literal
            callback(intl().formatMessage(messages.requiredRule, { item }))
          }
          callback()
        },
      },
    ],
  }
}
export function captchaRule(item) {
  return {
    rules: [
      {
        required: true,
        pattern: /^[a-zA-Z0-9]{4}$/,
        message: intl().formatMessage(messages.requiredRule, { item }),
      },
    ],
  }
}
export function OTPRule(item) {
  return {
    normalize: (value, prev) => {
      if (/^[0-9]{0,6}$/.test(value)) {
        return value
      }
      return prev
    },
    rules: [
      {
        required: true,
        pattern: /^[0-9]{6}$/,
        message: intl().formatMessage(messages.requiredRule, { item }),
      },
    ],
  }
}
export function nameRule(item = intl().formatMessage(messages.formItemName)) {
  return {
    validateTrigger: 'onBlur',
    rules: [
      {
        required: true,
        pattern: /^[a-zA-Z ]{2,50}$/,
        message: intl().formatMessage(messages.validRule, { item }),
      },
    ],
  }
}
export function cardNumberRule() {
  const message = intl().formatMessage(messages.validRule, {
    item: intl().formatMessage(messages.formItemCardNumber),
  })

  return {
    validateTrigger: 'onBlur',
    normalize: (value, prev) => {
      if (/^[0-9 ]*$/.test(value)) {
        const cardNo = getCardNumberDigits(value)
        if (cardNo.length > 19) {
          return prev
        }
        return cardNo
          ? cardNo.match(new RegExp('.{1,4}', 'g')).join(' ')
          : cardNo
      }
      return prev
    },
    rules: [
      {
        required: true,
        message,
      },
      {
        validator(rule, value, callback) {
          if (!value || isValidCardNumber(value)) {
            callback()
            return
          }
          callback(message)
        },
      },
    ],
  }
}
export function expireDateRule() {
  return {
    validateTrigger: 'onBlur',
    normalize: (value, prev) => {
      if (/^[0-9/]{0,5}$/.test(value)) {
        if (!value) {
          return value
        }
        if (value.length === 1 && Number(value) > 1) {
          // 首位大于1，自动补前面的0和后面的/
          return `0${value}/`
        }
        if (value.length === 2) {
          // 2位数，大于12禁止输入，反之允许输入并且后面补/，额外判断删除/的情况，保持输入新的值
          if (Number(value) > 12) {
            return prev
          }
          return prev.indexOf('/') !== -1 ? value : `${value}/`
        }
        return value
          .replace(/\//g, '')
          .match(new RegExp('.{1,2}', 'g'))
          .join('/')
      }
      return prev
    },
    rules: [
      {
        required: true,
        pattern: /^[0-9/]{5}$/,
        message: intl().formatMessage(messages.validRule, {
          item: intl().formatMessage(messages.formItemExpiryDate),
        }),
      },
      {
        validator: (rules, value, callback) => {
          // 判断录入有效期是否在当前时间下已过期
          const errors = []
          try {
            const [month, year] = value.split('/')
            const isExpired = moment(`${month}-${year}`, 'MM-YY')
              .endOf('month')
              .isBefore(new Date())
            if (isExpired) {
              errors.push(
                new Error(intl().formatMessage(messages.expireDateRule))
              )
            }
          } catch (error) {}
          callback(errors)
        },
      },
    ],
  }
}
export function securityCodeRule(isAmex = false) {
  return {
    validateTrigger: 'onBlur',
    normalize: (value = '', prev = '') => {
      const max = isAmex ? 4 : 3
      const reg = new RegExp(`^[0-9]{0,${max}}$`)
      if (reg.test(value)) return value
      return prev
    },
    rules: [
      {
        required: true,
        pattern: isAmex ? /^[0-9]{4}$/ : /^[0-9]{3}$/,
        message: intl().formatMessage(messages.validRule, {
          item: intl().formatMessage(messages.formItemSecurityCode),
        }),
      },
    ],
  }
}
export function ibanRule() {
  return {
    validateTrigger: 'onBlur',
    normalize: (value, prev) => {
      return value ? value.toUpperCase() : value
    },
    rules: [
      {
        required: true,
        pattern: /^AE[0-9]{21}$/,
        message: intl().formatMessage(messages.validRule, {
          item: intl().formatMessage(messages.formItemIABNNumber),
        }),
      },
    ],
  }
}
export function mobileRule() {
  return {
    validateTrigger: 'onBlur',
    normalize: (value = '', prev = '') => {
      if (!/^\d*$/.test(value)) {
        return prev
      }
      if (value === prev) {
        return value
      }
      if (value.length > 12) {
        return prev
      }
      return value
    },
    rules: [
      {
        required: true,
        min: 8,
        message: intl().formatMessage(messages.validRule, {
          item: intl().formatMessage(messages.formItemMobileNumber),
        }),
      },
    ],
  }
}

export function uaeMobileRule() {
  return {
    validateTrigger: 'onChange',
    normalize: (value = '', prev = '') => {
      if (!/^\d*$/.test(value)) {
        return prev
      }
      if (value === prev) {
        return value
      }
      if (value.length > 9) {
        return prev
      }
      return value
    },
    rules: [
      {
        required: true,
        len: 8,
        pattern: /^5[0-9]{8}$/,
        message: intl().formatMessage(messages.validRule, {
          item: intl().formatMessage(messages.formItemMobileNumber),
        }),
      },
    ],
  }
}
export function amountRule(item) {
  return {
    normalize: (value, prev) => {
      if (/^(([1-9]{1}\d*)|(0{1}))(\.\d{0,2})?$/.test(value) || value === '') {
        return value
      }
      return prev
    },
    rules: [
      {
        required: true,
        message: intl().formatMessage(messages.requiredRule, {
          item,
        }),
      },
    ],
  }
}
export function requiredArrayRule(item) {
  return {
    rules: [
      {
        required: true,
        type: 'array',
        min: 1,
        message: intl().formatMessage(messages.requiredRule, { item }),
      },
    ],
  }
}
export function emailRule(required) {
  return {
    validateTrigger: 'onBlur',
    normalize: (value, prev) => {
      if (/^[0-9a-zA-Z.@_]*$/.test(value) || value === '') {
        return value
      }
      return prev
    },
    rules: [
      {
        required: !!required,
        type: 'email',
        message: intl().formatMessage(messages.validRule, {
          item: intl().formatMessage(messages.formItemEmailAddress),
        }),
      },
    ],
  }
}
